<template>
  <div class="register_wrapper">
    <el-button icon="el-icon-refresh" @click="$refresh(getRegistersData)" class="refresh-btn">刷新</el-button>
    <div class="register">
      <!-- 条件查询 -->
      <div class="search">
        <el-form inline :model="searchForm">
          <el-form-item label="医生姓名">
            <el-select allow-create clearable v-model="searchForm.doctorName" placeholder="请选择医生" filterable
              default-first-option>
              <el-option v-for="item in doctorOptions" :key="item.value" :label="item.label" :value="item.label">
                <span class="fl">{{ item.label }}</span>
                <span class="select-flex">{{ item.phone }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getRegistersData, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getRegistersData, { doctorName: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button" v-if="deptId">
        <el-button icon="el-icon-plus" type="primary" @click="registerAdd">新增医生挂号信息</el-button>
      </div>
      <!-- 信息列表 -->
      <el-table v-loading="loading" :data="registerList" :max-height="tableHeight" border>
        <el-table-column type="index" label="序号" width="50" fixed="left" />
        <el-table-column prop="doctorName" label="医生姓名" width="90" fixed="left" />
        <el-table-column prop="registrationCommonPrice" label="挂号费用" />
        <el-table-column prop="registrationCommonNumber" label="挂号数量" />
        <el-table-column prop="registrationCommonIncreasePrice" label="加号费用" />
        <el-table-column prop="registrationContributingPrice" label="特约挂号费用" />
        <el-table-column prop="registrationContributingNumber" label="特约挂号数量" />
        <el-table-column prop="registrationContributingIncreasePrice" label="特约加号费用" />
        <el-table-column prop="registrationPhysioPrice" label="理疗号费用" />
        <el-table-column prop="registrationPhysioNumber" label="理疗号数量" />
        <el-table-column prop="registrationFreeNumber" label="义诊号数量" />
        <el-table-column prop="effectiveTime" label="生效日期" min-width="100" />
        <el-table-column prop="allocationTime" label="放号时间" />
        <el-table-column prop="deptName" label="医馆名称" v-if="!deptId" />
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button icon="el-icon-edit" type="primary" @click="editRegister(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="dialogEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="760px"
        :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" :rules="editFormRules" inline label-width="120px">
          <el-form-item label="医生姓名" prop="doctorId">
            <el-select v-model="editForm.doctorId" placeholder="请选择医生" filterable default-first-option>
              <el-option v-for="item in doctorOptions" :key="item.value" :label="item.label" :value="item.value">
                <span class="fl">{{ item.label }}</span>
                <span class="select-flex">{{ item.phone }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="挂号费用" prop="registrationCommonPrice">
            <el-input v-model.number="editForm.registrationCommonPrice" placeholder="请输入挂号费用"><template
                slot="append">元</template></el-input>
          </el-form-item>
          <el-form-item label="挂号数量" prop="registrationCommonNumber">
            <el-input v-model.number="editForm.registrationCommonNumber" placeholder="请输入挂号数量"><template
                slot="append">个</template></el-input>
          </el-form-item>
          <el-form-item label="加号费用" prop="registrationCommonIncreasePrice">
            <el-input v-model.number="editForm.registrationCommonIncreasePrice" placeholder="请输入加号费用"><template
                slot="append">元</template></el-input>
          </el-form-item>
          <el-form-item label="义诊数量" prop="registrationFreeNumber">
            <el-input v-model.number="editForm.registrationFreeNumber" placeholder="请输入义诊号数量"><template
                slot="append">个</template></el-input>
          </el-form-item>
          <el-form-item label="放号提前天数" prop="allocationDay">
            <el-input v-model.number="editForm.allocationDay" placeholder="请输入放号提前天数"><template
                slot="append">天</template></el-input>
          </el-form-item>
          <div v-if="dialogTitle == '编辑医生挂号信息'">
            <el-form-item label=" ">
              <el-checkbox v-model="editForm.isEffective">修改生效时间</el-checkbox>
            </el-form-item>
            <el-form-item label="信息生效时间" prop="effectiveTime">
              <el-date-picker value-format="yyyy-MM-dd" v-model="editForm.effectiveTime" type="date" placeholder="选择生效日期"
                :disabled="editForm.isEffective == false" />
            </el-form-item>
          </div>
          <div>
            <el-form-item label=" ">
              <el-checkbox v-model="editForm.isContributing">特约门诊</el-checkbox>
            </el-form-item>
          </div>
          <div v-if="editForm.isContributing == true">
            <el-form-item label="特约挂号费用" prop="registrationContributingPrice">
              <el-input v-model.number="editForm.registrationContributingPrice" placeholder="请输入特约号挂号费"><template
                  slot="append">元</template></el-input>
            </el-form-item>
            <el-form-item label="特约挂号数量" prop="registrationContributingNumber">
              <el-input v-model.number="editForm.registrationContributingNumber" placeholder="请输入特约号数量"><template
                  slot="append">个</template></el-input>
            </el-form-item>
            <el-form-item label="特约加号费用" prop="registrationContributingIncreasePrice">
              <el-input v-model.number="editForm.registrationContributingIncreasePrice" placeholder="请输入特约加号费用"><template
                  slot="append">元</template></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label=" ">
              <el-checkbox v-model="editForm.isPhysio">理疗门诊</el-checkbox>
            </el-form-item>
          </div>
          <div v-if="editForm.isPhysio == true">
            <el-form-item label="理疗挂号费用" prop="registrationPhysioPrice">
              <el-input v-model.number="editForm.registrationPhysioPrice" placeholder="请输入理疗号挂号费"><template
                  slot="append">元</template></el-input>
            </el-form-item>
            <el-form-item label="理疗挂号数量" prop="registrationPhysioNumber">
              <el-input v-model.number="editForm.registrationPhysioNumber" placeholder="请输入理疗号数量"><template
                  slot="append">个</template></el-input>
            </el-form-item>
          </div>
          <el-form-item label="设置放号时间" prop="isCustomAllocationTime">
            <el-radio-group v-model="editForm.isCustomAllocationTime">
              <el-radio :label="'否'" />
              <el-radio :label="'是'" />
            </el-radio-group>
          </el-form-item>
          <el-form-item label="放号时间" prop="allocationTime" v-if="editForm.isCustomAllocationTime == '是'">
            <el-time-select v-model="editForm.allocationTime"
              :picker-options="{ start: '00:00', step: '00:10', end: '23:50' }" placeholder="选择时间" />
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" v-if="dialogTitle == '新增医生挂号信息'" @click="addSave">保存新增</el-button>
          <el-button type="success" v-if="dialogTitle == '编辑医生挂号信息'" @click="editSave">保存修改</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getRegistersData)" :total="total"
        :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
    </div>
  </div>
</template>

<script lang="js">
import { registerList, registerEdit, registerAdd } from "@/api/register"; // 引入挂号信息请求
import { positiveInteger } from '@/utils/regexp'
import { checkReg } from '@/utils/validateBase'
import { isNull } from "@/utils/validateBase";
export default {
  name: "Register",
  data() {
    let checkPositiveInteger = (rule, value, callback) => {
      if (!checkReg(positiveInteger, value)) {
        return callback(new Error(`请输入正整数`));
      }
      return callback();
    }
    return {
      loading: true, // 加载中
      searchForm: { doctorName: null }, // 查询表单
      registerList: [], // 医生挂号信息列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      editForm: {}, // 新增或编辑数据
      dialogTitle: null, // 弹框标题
      dialogVisible: false, // 新增或编辑弹框状态
      deptId: this.$session.get("deptId"),
      editFormRules: {
        doctorId: [{ required: true, message: "医生姓名不能为空！", trigger: "change" }],
        registrationCommonPrice: [{ required: true, message: "挂号费不能为空！" },{ validator: checkPositiveInteger, trigger: 'blur' }],
        registrationCommonNumber: [{ required: true, message: "挂号数量不能为空！" }, { validator: checkPositiveInteger, trigger: 'blur' }],
        registrationCommonIncreasePrice: [{ required: true, message: "加号挂号费不能为空！" }, { validator: checkPositiveInteger, trigger: 'blur' }],
        registrationFreeNumber: [{ required: true, message: "义诊数量不能为空！" }, { validator: checkPositiveInteger, trigger: 'blur' }],
        registrationContributingPrice: [{ required: true, message: "特约号挂号费不能为空！" }, { validator: checkPositiveInteger, trigger: 'blur' }],
        registrationContributingNumber: [{ required: true, message: "特约号数量不能为空！" }, { validator: checkPositiveInteger, trigger: 'blur' }],
        registrationContributingIncreasePrice: [{ required: true, message: "特约加号挂号费不能为空！" }, { validator: checkPositiveInteger, trigger: 'blur' }],
        registrationPhysioPrice: [{ required: true, message: "理疗号挂号费不能为空！" }, { validator: checkPositiveInteger, trigger: 'blur' }],
        registrationPhysioNumber: [{ required: true, message: "理疗号数量不能为空！" }, { validator: checkPositiveInteger, trigger: 'blur' }],
        allocationDay: [{ required: true, message: "提前放号天数不能为空！", trigger: "blur" }, { validator: checkPositiveInteger, trigger: 'blur' }],
        allocationTime: [{ required: true, message: "放号时间不能为空！", trigger: "change" }],
        effectiveTime: [{ required: true, message: "生效时间不能为空！", trigger: "change" }],
      }, // 验证规则
      tableHeight: 0, // 表格最大高度
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.getRegistersData();
  },
  props: { doctorOptions: Array }, // 接收父组件传递的参数
  methods: {
    // 请求所有医生挂号信息列表
    async getRegistersData() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { total, rows, code } = await registerList(params);
      if (code == 200) {
        if (total > 0) {
          rows.forEach(item => {
            this.$session.get("options").forEach(items => {
              if (item.deptId == items.value) item.deptName = items.label;
            });
            item.doctorName = item.hospDoctorInfo.doctorName;
            item.isCustomAllocationTime == 1 ? item.isCustomAllocationTime = "是" : item.isCustomAllocationTime = "否";
            item.isContributing == 1 ? item.isContributing = true : item.isContributing = false;
            item.isPhysio == 1 ? item.isPhysio = true : item.isPhysio = false;
            item.allocationTime = this.$computeTime(isNull(item.allocationTime)?0: item.allocationTime)
            item.isEffective = false;
          });
        }
        this.total = total;
        this.registerList = rows;
      }
      this.loading = false;
    },
    // 新增医生挂号信息
    registerAdd() {
      this.dialogTitle = "新增医生挂号信息";
      this.dialogVisible = true;
      this.editForm = {
        doctorId: null, registrationCommonPrice: null, registrationCommonNumber: null, registrationCommonPrice: null, registrationContributingPrice: null,
        registrationContributingNumber: null, registrationContributingIncreasePrice: null, registrationPhysioPrice: null, registrationPhysioNumber: null,
        registrationFreeNumber: null, isCustomAllocationTime: "否", allocationTime: "00:00", allocationDay: 15, isContributing: false, isPhysio: false, deptId: this.deptId
      }
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          registerAdd(this.handle()).then(res => {
            let { code } = res;
            if (code == 200) this.$message.success("新增医生挂号信息成功！");

            this.dialogVisible = false;
            this.$refresh(this.getRegistersData);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 编辑医生挂号信息
    editRegister(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.dialogTitle = "编辑医生挂号信息";
      this.dialogVisible = true;
    },
    // 保存医生挂号信息修改
    editSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          registerEdit(this.handle()).then(res => {
            let { code } = res;
            if (code == 200) this.$message.success("修改医生挂号信息成功！");

            this.dialogVisible = false;
            this.$refresh(this.getRegistersData);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 处理参数
    handle() {
      let params = JSON.parse(JSON.stringify(this.editForm));
      params.isContributing == true ? params.isContributing = 1 : params.isContributing = 0;
      params.isPhysio == true ? params.isPhysio = 1 : params.isPhysio = 0;
      params.allocationTime = parseInt(params.allocationTime.substring(0, 2)) * 60 + parseInt(params.allocationTime.substring(3));
      params.isCustomAllocationTime == "是" ? params.isCustomAllocationTime = 1 : params.isCustomAllocationTime = 0;

      if (params.isContributing == 0) params.registrationContributingNumber = params.registrationContributingPrice = params.registrationContributingIncreasePrice = 0; // 不设置特约
      if (params.isPhysio == 0) params.registrationPhysioNumber = params.registrationPhysioPrice = 0; // 不设置理疗

      if (params.isEffective != undefined) params.isEffective == false ? params.effectiveTime = null : params.effectiveTime = params.effectiveTime;
      return params;
    }
  }
};
</script>

<style lang="less" scoped>
.register_wrapper {
  box-sizing: border-box;
  padding: 20px;
}
.register {
  width: 100%;

  &>div:not(:last-child) {
    margin-bottom: 20px;
  }

  .dialogEdit {
    .el-form-item {
      width: 50%;
      margin-right: 0;
    }

    /deep/.el-input-group__append {
      padding: 0 10px;
    }
  }
}</style>